import React, { useState, useEffect, FormEvent } from 'react';
import DocumentList from '../../components/DocumentList';
import { getJobList } from '../../utils/Api';

interface DocumentListType {
  [key: string]: any; // Adjust if you know the exact structure of documents
}

const Search: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [documentList, setDocumentList] = useState<DocumentListType>({});
  const [error, setError] = useState<string | null>(null);

  const search = async () => {
    try {
      const { data } = await getJobList(searchQuery);
      setDocumentList(data);
    } catch (err: any) {
      setError(err.message);
    }
  };

  const handleSearch = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    search();
  };

  useEffect(() => {
    search();
  }, []);

  return (
    <div className="flex-grow flex flex-col items-center justify-center">
      <div className="flex-grow max-w-200 my-5 p-4 shadow-lg rounded-lg bg-stone-100 flex flex-col gap-4">
        <form className="h-15 w-full flex flex-row gap-3" onSubmit={handleSearch}>
          <input
            name="Search"
            type="text"
            placeholder="Type to search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full p-2 border bg-white border-gray-300 rounded-lg"
          />
          <button
            type="submit"
            aria-label="Search"
            className="text-white bg-(--dr-dark) hover:bg-(--dr-dark-var) font-medium rounded-2xl px-5 py-2.5 duration-150"
          >
            Search
          </button>
        </form>
        <DocumentList documentList={documentList} setDocumentList={setDocumentList} />
      </div>
    </div>
  );
};

export default Search;
